module.exports = __webpack_public_path__ + "img/distintivo.9de84df0.png";